import { REQUEST_URL } from "../constants";
import { RequestUtil, RequestFileUtil } from "../utils";
import { BannerInputModel, BannerIndexInputModel, PaginationLanguageQueryModel } from "../models"

export const BannerService = {
  getAllBannerByLanguage,
  getBanner,
  createBanner,
  uploadImageBanner,
  updateBanner,
  updateBannerIndex,
  deleteBanner
};

async function getAllBannerByLanguage(query: PaginationLanguageQueryModel & { searchValue?: string }) {
  const url = REQUEST_URL.GET_ALL_BANNER_BY_LANGUAGE;

  return RequestUtil.get({ url, query });
}

async function getBanner(code: string, query?: { languageId?: string }) {
  const url = REQUEST_URL.GET_BANNER.replace("{CODE}", code);;

  return RequestUtil.get({ url, query });
}

async function createBanner(data: BannerInputModel[]) {
  const url = REQUEST_URL.CREATE_BANNER;

  return RequestUtil.post({ url, data });
}

async function uploadImageBanner(formData: FormData) {
  const url = REQUEST_URL.IMAGE.UPLOAD_BANNER;

  return RequestFileUtil.post({ url, data: formData });
}

async function updateBanner(code: string, data: BannerInputModel[]) {
  const url = REQUEST_URL.UPDATE_BANNER.replace("{CODE}", code);

  return RequestUtil.put({ url, data });
}

async function updateBannerIndex(data: BannerIndexInputModel[]) {
  const url = REQUEST_URL.UPDATE_BANNER_INDEX;

  return RequestUtil.put({ url, data });
}

async function deleteBanner(code: string) {
  const url = REQUEST_URL.DELETE_BANNER.replace("{CODE}", code);

  return RequestUtil.delete({ url });
}